import { NgModule } from '@angular/core';
import { SafeCommentPipe } from './safe-comment.pipe';
import { ImagePathPipe } from './image-path.pipe';

@NgModule({
    declarations: [
        SafeCommentPipe,
        ImagePathPipe
    ],
    exports: [
        SafeCommentPipe,
        ImagePathPipe
    ]
})
export class AllPipeModule {
}
